export default __webpack_public_path__ + "static/media/shortcut.0037ed6f.svg";